import { PlaceholdersId, TFComponent } from '@types';
import { DoubtsAndExitPlaceholder } from './doubtsAndExit';

export const doubtsAndExit: TFComponent = {
	component: DoubtsAndExitPlaceholder,
	id: PlaceholdersId.doubtsAndExit,
	name: 'doubtsAndExit',
};
